<template lang="html">
  <img
    class="playing-card"
    :class="{ visible }"
    :src="imageSrc"
    :alt="name"
    @load="handleImageLoad"
  />
</template>

<script>
export default {
  name: 'PlayingCard',

  props: {
    suit: {
      type: String,
      required: true,
    },

    rank: {
      type: String,
      required: true,
    },

    showingFace: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      visible: false,
    };
  },

  computed: {
    name() {
      // TODO: Return something human readable like `Ace of hearts`.
      return `${this.suit} ${this.rank}`;
    },

    imageSrc() {
      return this.showingFace
        ? require(`@/assets/images/cards/${this.rank.toLowerCase()}${this.suit.toLowerCase()}.png`)
        : require('@/assets/images/cards/back.png');
    },
  },

  methods: {
    handleImageLoad() {
      this.visible = true;
      this.$emit('image-loaded', { suit: this.suit, rank: this.rank });
    },
  },
};
</script>

<style scoped lang="scss">
@mixin card-size($width) {
  $natural-width: 400px;
  $natural-height: 560px;
  $dimensions-ratio: $natural-height / $natural-width;
  $height: $width * $dimensions-ratio;

  width: $width;
  height: $height;
}

.playing-card {
  @include card-size(85px);

  overflow: hidden;
  border-radius: 4px;
  opacity: 0;
  display: block;
  box-shadow: 0px 1px 2px map-get($colors, 'faded-background-5x');

  &.visible {
    opacity: 1;
  }
}

@media all and (min-width: map-get($breakpoints, 'phone')) {
  .playing-card {
    @include card-size(125px);

    // This only looks good when the cards are not overlapping (non-mobile).
    transition: opacity map-get($transition-speeds, 'fast') ease-out;
  }
}
</style>
